import React, { useEffect, useState } from 'react'
import { FaPlus, FaEdit } from 'react-icons/fa'
import Empty from '../feedback/Empty'
import Loading from '../feedback/Loading'
import moment from 'moment'
import adminServices from '../../services/AdminServices'
import AmenityModal from '../houses/AmenityModal'
import { RenderIcon } from '../houses/IconRenderer'

function Amenities() {
    const [amenities, setAmenities] = useState([])
    const [loading, setLoading] = useState(false)
    const [action, setAction] = useState(0) 
    const [activeAmenity, setActiveAmenity] = useState(null)

    useEffect(() => {
        fetchAmenities()
    }, [])

    const fetchAmenities = () => {
        setLoading(true)
        adminServices.adminListAmenities()
            .then(res => {
                const data = res.data || []
                setAmenities(data)
                setLoading(false)
            })
            .catch(err => {
                console.error('Failed to fetch amenities:', err)
                setLoading(false)
            })
    }

    const openModal = (actionType, amenity = null) => {
        setAction(actionType)
        setActiveAmenity(amenity)
        document.getElementById('amenity-open-btn')?.click()
    }

    return (
        <div className='space-y-5 w-full'>
            {/* Header */}
            <div className="flex justify-between items-center">
                <h3 className='text-xl text-primary font-bold'>
                    House Amenities{' '}
                    <span className='ml-2 text-on-surface-variant/60 text-base font-normal'>
                        ({amenities.length})
                    </span>
                </h3>
                <button
                    onClick={() => openModal(0)}
                    className='btn btn-primary rounded-xl btn-sm gap-2'
                >
                    <FaPlus /> Add Amenity
                </button>
            </div>

            <AmenityModal
                action={action}
                activeAmenity={activeAmenity}
                onReload={fetchAmenities}
                setActiveAmenity={setActiveAmenity}
            />

            <div className="bg-white rounded-xl border border-outline-variant/15 overflow-hidden">
                <div className='overflow-x-auto'>
                    <table className="table table-zebra w-full">
                        <thead>
                            <tr>
                                <th>Icon</th>
                                <th>Name</th>
                                <th className='hidden md:table-cell'>Properties</th>
                                <th className='hidden md:table-cell'>Created</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {amenities?.length ? (
                                amenities.map((amen) => (
                                    <tr key={amen.id}>
                                        <td>
                                            {amen.icon_class ? (
                                                <RenderIcon
                                                    iconName={amen.icon_class}
                                                    className="text-primary text-lg"
                                                />
                                            ) : (
                                                <span className="text-on-surface-variant/40 text-sm">—</span>
                                            )}
                                        </td>
                                        <td className='font-semibold text-primary'>{amen.name}</td>
                                        <td className='hidden md:table-cell text-xs text-on-surface-variant/60'>
                                            {amen.house_count || 0}
                                        </td>
                                        <td className='hidden md:table-cell text-xs text-on-surface-variant/60'>
                                            {amen.created_at ? moment(amen.created_at).format('MMM Do, YYYY') : '—'}
                                        </td>
                                        <td>
                                            <div className="flex gap-2">
                                                <button
                                                    onClick={() => openModal(1, amen)}
                                                    className='btn btn-secondary btn-sm rounded-xl text-white'
                                                    title="Edit"
                                                >
                                                    <FaEdit /> Edit
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : null}
                        </tbody>
                    </table>

                    {loading && <Loading />}
                    {!amenities?.length && !loading && (
                        <div className="p-6">
                            <Empty objectName="Amenities" />
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Amenities